import { Col, Row } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOverChargeClaimEmailDetailsInProgress } from '../../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { getLabelFromDateTime } from '../../../../../../../../utilz/dates';
import EmptyRecords from '../../../../../../../components/Common/EmptyRecords';
import BatchLabel from '../../../../../../../components/Labels/BatchLabel';
import PrimaryLabel from '../../../../../../../components/Labels/PrimaryLabel';
import CommonModal from '../../../../../../../components/Modals/CommonModal';
import Paper from '../../../../../../../components/Paper/Paper';
import ContentSpinner from '../../../../../../../components/Spinners/ContentSpinner';
import TMSFiledCard from '../../../../../../common/components/TMSFiledCard';

const OverChargeClaimEmailDetailsModal = ({ open, setOpen, fbocKey }) => {
  const dispatch = useDispatch();
  const { claimEmailHistory } = useSelector((state) => state.overChargeClaims);
  useEffect(() => {
    if (fbocKey) {
      dispatch(getOverChargeClaimEmailDetailsInProgress(fbocKey));
    }
  }, [fbocKey]);

  return (
    <CommonModal
      title="Email Tracking Details"
      open={open}
      onClose={() => setOpen(false)}
      customFooter={<></>}
      descriptionClassName="d-flex h-100"
      className="vw-90"
    >
      <div className="flex-1 custom-scroll-bar">
        {claimEmailHistory.progressing ? (
          <ContentSpinner size="large" />
        ) : (
          <>
            {claimEmailHistory?.data?.length > 0 ? (
              <>
                {claimEmailHistory.data.map((row, key) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                  <EmailCard key={key} data={row} />
                ))}
              </>
            ) : (
              <>
                <EmptyRecords title="There is no email records found!" descriptionOne="" descriptionTwo="" />
              </>
            )}
          </>
        )}
      </div>
    </CommonModal>
  );
};

export default OverChargeClaimEmailDetailsModal;

const EmailCard = ({ data }) => {
  return (
    // biome-ignore lint/style/noUnusedTemplateLiteral: <explanation>
    <Paper className={`border-muted mb-15`}>
      <div className="border-bottom-muted pt-8 pb-3 px-16">
        <Row gutter={15} align="middle">
          <Col>
            <TMSFiledCard containerClass="d-flex align-items-center" title="Claim Key: ">
              <PrimaryLabel className="ml-5">{data.claimKey}</PrimaryLabel>
            </TMSFiledCard>
          </Col>
          <Col>
            <TMSFiledCard containerClass="d-flex align-items-center" title="Senders Email: ">
              <PrimaryLabel className="ml-5">{data.sendersEmail}</PrimaryLabel>
            </TMSFiledCard>
          </Col>
          <Col className="flex-1">
            <Row justify="end" align="middle">
              <Col>
                <TMSFiledCard containerClass="d-flex align-items-center" title="Status: ">
                  <BatchLabel className="ml-5">{data.statusDesc}</BatchLabel>
                </TMSFiledCard>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="p-15">
        <Row gutter={15}>
          <Col sm={5}>
            <TMSFiledCard title="Recipient">{data.recipient}</TMSFiledCard>
          </Col>
          <Col sm={4}>
            <TMSFiledCard title="Sent On">{getLabelFromDateTime(data.sentOn)}</TMSFiledCard>
          </Col>
          <Col sm={7}>
            <TMSFiledCard title="Email Subject">{data.emailSubject}</TMSFiledCard>
          </Col>

          <Col sm={4}>
            <TMSFiledCard title="Description">{data.description}</TMSFiledCard>
          </Col>
          <Col sm={4}>
            <TMSFiledCard title="Date Time Of Action">{getLabelFromDateTime(data.dateTimeOfAction)}</TMSFiledCard>
          </Col>
        </Row>
      </div>
    </Paper>
  );
};
